import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ManualConsiliation from './ManualConsiliation';
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";

//Api 
import { OrdersFetchAPI } from '../../../api/Orders';
import { BankConsilationFetchAPI } from "../../../api/BankConsilation";

//Utils
import { RenderIf } from "../../utils/RenderIf";
//Alerts 
import ErrorAlert from '../../Alerts/ErrorAlert';
import SuccessAlert from '../../Alerts/SuccessAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';
import { use } from 'react';

const LotInfoTransaction = ({ selectedStatement, setSelectedStatement, selectedTransactionStatementIndex, description, reference, date, amount, minSelectedDate, maxSelectedDate, business_code, user, token, bankStatementId, setBankStatementEventHandler }) => {

    const [showModal, setShowModal] = useState(false);
    const [orders, setOrders] = useState([]);
    const [groupedTransactions, setGroupedTransactions] = useState([]);
    const [ordersDataToSend, setOrdersDataToSend] = useState([]);
    const [dataPage, setDataPagePage] = useState(0);
    const [files, setFiles] = useState([]);
    const [columns, setColumns] = useState([]);
    const [excelData, setExcelData] = useState([]);
    const [eventHandler, setEventHandler] = useState(0);
    const [justification, setJustification] = useState("");
    const [someConsiliated, setSomeConsiliated] = useState(false);
    let ordersDataPerPage = 5;

    //Function to get the orders from the backend
    const getOrders = async () => {
        try {
            let response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethodbyUser(business_code, 0, minSelectedDate, maxSelectedDate, 0, user.id, token, undefined, undefined, true);
            //We set the orders
            setOrders(response.data.orders);
            setOrdersDataToSend(response.data.orders);
            groupTransactions(response.data.orders);

        } catch (err) {
            console.log(err);
            setOrders([]);
            setOrdersDataToSend([]);
            groupTransactions([]);
        }
    }

    //Function to group the transactions by date and payment method
    const groupTransactions = (transactions) => {
        let grouped = {};
        transactions.forEach(tx => {
            //We get the date and payment method to group the transactions
            let key = `${tx.paymenthod}-${tx.createdAt.split("T")[0]}`;
            let consiliation = tx.consiliation !== undefined && tx.consiliation !== false ? tx.consiliation : false;
            //We check if the transaction is consiliated is not consiliated we set the consiliation to false and we agroup the transactions
            if (consiliation === false) {
                if (!grouped[key]) {
                    grouped[key] = {
                        createdAt: tx.createdAt.split("T")[0],
                        paymenthod: tx.paymenthod,
                        total: 0,
                        count: 0,
                        orders: [],
                        consiliation: false,
                        consiliationType: "No consolidado",

                    };
                }
                grouped[key].total += tx.total_with_tips;
                grouped[key].count += 1;
                grouped[key].orders.push(tx);
            }
        });
        setGroupedTransactions(Object.values(grouped));
    };

    //Pagination
    const handlePageChange = ({ selected }) => {
        setDataPagePage(selected);
    };
    //We get the data to show in the table
    let ordersData = orders.slice(dataPage * ordersDataPerPage, (dataPage + 1) * ordersDataPerPage);

    //Dropzone fILE
    const [fileName, setFileName] = useState('No hay ningún archivo seleccionado');

    //Function to handle the file change
    const handleFileChange = (e) => {
        LoadingAlert("Cargando archivo", "Espere un momento por favor");
        //We wait for the file to be read
        setTimeout(async () => {
            //We check if the file is selected
            if (e.target.files.length > 0) {
                setFileName(e.target.files[0].name);
                const selectedFiles = Array.from(e.target.files);
                //We set the files to the state
                setFiles(selectedFiles);
                let allData = [];
                let allColumns = [];
                const fileReadPromises = selectedFiles.map((file) => {
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = (event) => {
                            try {
                                const workbook = XLSX.read(event.target.result, { type: "binary" });
                                const sheetName = workbook.SheetNames[0];
                                const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

                                allColumns = [...allColumns, ...sheetData[0]];
                                allData = [...allData, ...sheetData.slice(1)];

                                resolve(); // Resolviendo después de procesar correctamente
                            } catch (error) {
                                reject(error); // En caso de error en lectura/procesamiento
                            }
                        };
                        reader.onerror = () => reject(reader.error);
                        reader.readAsArrayBuffer(file);
                    });
                });
                try {
                    await Promise.all(fileReadPromises);
                    setColumns(allColumns);
                    setExcelData(allData);
                    //We set the data to send to the backend
                    SuccessAlert("Archivo cargado", "El archivo se ha cargado correctamente", "success");
                    setEventHandler(1);
                } catch (error) {
                    console.error("Error procesando archivos:", error);
                    ErrorAlert("Error procesando archivos", "error", "warining");

                }

            } else {
                setFileName('No hay ningún archivo seleccionado');
                //We make the alert
                ErrorAlert("No hay ningún archivo seleccionado", "error", "warining");
            }
        }, 2000);
    };

    //Function to handle the change data on the frontend
    const handleChangeData = async () => {
        if (!excelData.length || !ordersDataToSend.length) {
            ErrorAlert("No hay datos para conciliar", "error", "warining");
            return;
        } else {
            const payload = {
                lote_reference: reference,
                transactions_db: ordersDataToSend, // Backend transactions 
                transactions_excel: excelData.map((row) => ({
                    referenceIndex: columns.findIndex(element => element === selectedStatement.bankStatementTemplate.template.reference), //  La columna seleccionada como referencia
                    raw_data: row, // We save the row for next steps 
                }))
            };


            //We send the data to the backend
            const response = await BankConsilationFetchAPI.getConsilationLoteReport(payload, token);

            // Update the state of the orders with the consiliation data
            const updatedOrders = orders.map(order => {
                const isMatched = response.data.matched.findIndex(match => match.reference === order.transaction_code);
                if (isMatched !== -1) {
                    return {
                        ...order,
                        consiliation: true,
                        consiliationType: "Automatica"
                    };
                } else {
                    return {
                        ...order,
                        consiliation: false,
                        consiliationType: "No consiliada"
                    }
                }
            });
            //We set the orders with the new data
            setOrders(updatedOrders);
            setOrdersDataToSend(updatedOrders);
            //We set the some consiliated to true
            setSomeConsiliated(true);
            // Alert 
            SuccessAlert("Conciliación realizada", "La conciliación se ha realizado con éxito", "success");

        }

    };

    //Function to save the batch  
    const saveConsiliatedBatch = async () => {
        try {
            //We filter all the orders that are consiliated
            let ordersToSend = ordersDataToSend.filter(order => order.consiliation === true);
            //We make the json to send to the backend
            let data = {
                orders: ordersToSend,
                lote_reference: reference,
                totalExcel: excelData.length,
                totalSystem: ordersToSend.length,
                business_code: business_code,
                justification: justification,
                bankStatementId: bankStatementId, // ID de la conciliación bancaria
            }
            //We send the data to the backend
            await BankConsilationFetchAPI.saveBankConciliationBatch(data, token);
            //We show the alert
            SuccessAlert("Lote guardado", "La conciliación del lote se ha guardado con éxito", "success");
            //We clean the orders
            setOrders([]);
            setOrdersDataToSend([]);
            //We clean the files
            setFiles([]);
            setExcelData([]);
            setShowModal(false)
            //We recharge the data to show in the table
            selectedStatement.transactions[selectedTransactionStatementIndex].status = "completed";
            setSelectedStatement(selectedStatement);
            setBankStatementEventHandler(1);
            //We set the event handler to 1 to show the alert
            setJustification("");
        } catch (err) {
            console.log(err);
            //we show an error 
            ErrorAlert(err.response.data.error !== undefined ? err.response.data.error : "Ha ocurrido un error al guardar la el lote con la transaccion", "Advertencia", "warning");
        }
    }

    //Function to handle the assign of the batch
    const handleAssign = (date, paymentMethod, updatedTransactions, batchReference) => {

        //We set the grouped transactions with the new data
        setGroupedTransactions(prev =>
            prev.map(group =>
                group.createdAt === date && group.paymenthod === paymentMethod
                    ? { ...group, consiliation: true, consiliationType: "Manual", lote_reference: batchReference, orders: updatedTransactions }
                    : group
            )
        );

        //For the updated transactions we set the consiliation to true and the consiliation type to manual
        setOrdersDataToSend(prev =>
            prev.map(order =>
                updatedTransactions.find(updatedOrder => updatedOrder._id === order._id)
                    ? { ...order, consiliation: true, consiliationType: "Manual" }
                    : order
            )
        );
        //We set the orders with the new data
        setOrders(prev =>
            prev.map(order =>
                updatedTransactions.find(updatedOrder => updatedOrder._id === order._id)
                    ? { ...order, consiliation: true, consiliationType: "Manual" }
                    : order
            )
        );

        groupTransactions(ordersDataToSend.map(order =>
            updatedTransactions.find(updatedOrder => updatedOrder._id === order._id)
                ? { ...order, consiliation: true, consiliationType: "Manual" }
                : order
        ));
        //We set the some consiliated to true
        setSomeConsiliated(true);

        //Alert to show the success of the assign
        SuccessAlert("Lote asignado", "El lote se ha asignado correctamente", "success");
    };

    //Function to handle to change the data 
    useEffect(() => {
        if (eventHandler === 0) return;
        setTimeout(() => {
            handleChangeData();
            //We set the some consiliated to true
            setSomeConsiliated(false);
        }, 2000);
        setEventHandler(0);
    }, [eventHandler]);
    return (
        <>

            <div>
                <button className='btn btn-primary  bg-white btn-sm  fw-normal text-primary  border-0 rounded-2 text-nowrap '
                    onClick={() => { setShowModal(true); getOrders() }} >
                    <i class="uil uil-file-upload-alt"></i>  Subir lote
                </button>
            </div>


            <Modal size="xl" show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Body>
                    <div className=' position-relative'>
                        <div className='position-absolute top-0 start-100 translate-middle  '>
                            <div className='me-3'>
                                <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1" type="button" variant="secondary"
                                    onClick={() => setShowModal(false)} title='Cerrar'>
                                    <i class="uil uil-multiply"></i>
                                    <span class="visually-hidden">Dismiss</span>
                                </button>
                            </div>
                        </div>
                        <h2 className="title-main-login  text-center  mt-lg-2"> <i class="fa-solid fa-money-bill-transfer"></i> Importación de Lotes</h2>
                        <div className=" p-3 bg-white rounded-3 border mt-2">
                            <section >

                                <div className="">
                                    <div className=' w-100  m-1 p-2 '>
                                        <div className='d-flex justify-content-between align-items-center mb-2'>
                                            <h6 className="fw-semibold"> Transacción</h6>


                                            <button onClick={() => { saveConsiliatedBatch() }} className="fw-semibold btn btn-save-sp">Guardar Cambios</button>

                                        </div>

                                        <div class="card border border-success-subtle border-2 " role='button' >
                                            <div class="card-body">
                                                <div class="d-flex justify-content-between">
                                                    <div class="flex-column align-items-center">
                                                        <h5 class="card-text">{description}</h5>
                                                        <h6 class="card-subtitle mb-2 text-body-secondary">Referencia: {reference}</h6>
                                                    </div>
                                                    <div>

                                                        <span className='text-on fw-semibold' ><span >{amount <= 0 ? "Debito" : "Credito"}: ${amount} </span> </span>

                                                    </div>

                                                </div>

                                                <p class="card-text">Fecha:{date}</p>

                                            </div>
                                        </div>
                                    </div>

                                    <div className='border-3'>
                                        {/* <input type="file" accept=".xlsx, .xls" onChange={handleLotFileUpload} /> */}

                                        <div className='d-flex justify-content-between gap-2 align-items-center mt-2'>
                                            <h6 className="fw-semibold"> Listado de trasacciones</h6>
                                            {/* ----------------------------------------- */}
                                            <div class="button-wrapper  " role='button' >


                                                <button role='button' class="label  rounded-2 btn btn-primary ">
                                                    Subir lote
                                                </button>

                                                <input type="file" name="upload" id="upload" multiple
                                                    accept=".xlsx, .xls" onChange={(e) => {
                                                        handleFileChange(e);

                                                    }}
                                                    className="upload-box" placeholder="Upload File"
                                                />
                                            </div>
                                            {/* ----------------------------------------- */}
                                            <ManualConsiliation
                                                description={description}
                                                reference={reference}
                                                date={date}
                                                amount={amount}
                                                groupedTransactions={groupedTransactions}
                                                handleAssign={handleAssign}
                                                setJustification={setJustification}
                                            />
                                        </div>
                                    </div>
                                    <div className='wrapper-bank p-2'>
                                        <table className="table table-hover mt-2">
                                            <thead>
                                                <tr className='table-dark'>
                                                    <th>Fecha</th>
                                                    <th>Metodo de pago</th>
                                                    <th>Transacción</th>
                                                    <th>Monto</th>
                                                    <th>Tipo de conciliacion</th>
                                                    <th>Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {ordersData.map((tx, idx) => (
                                                    <RenderIf isTrue={tx.consiliation !== undefined && tx.consiliation !== false}>
                                                        <tr key={idx}>
                                                            <td>{tx.createdAt.split("T")[0]}</td>
                                                            <td>{tx.paymenthod}</td>
                                                            <td>{tx.transaction_code}</td>
                                                            <td>${tx.total_with_tips}</td>
                                                            <td>{tx.consiliationType !== undefined && tx.consiliationType !== null && tx.consiliationType !== "No consiliada" ?
                                                                <span className='rounded-pill text-on icon-on small px-2'> <i class="uil uil-check"></i> {tx.consiliationType}</span>
                                                                :
                                                                <span className='rounded-pill border text-secondary small px-2'> <i class="uil uil-spinner"></i> No Encontrado</span>
                                                            }</td>
                                                            <td>{tx.consiliation !== undefined && tx.consiliation !== false ?
                                                                <span className='rounded-pill text-on icon-on small px-2'> <i class="uil uil-check"></i> Encontrado</span>
                                                                :
                                                                <span className='rounded-pill border text-secondary small px-2'> <i class="uil uil-spinner"></i> No Encontrado</span>

                                                            }</td>
                                                            {/*                                <RenderIf isTrue={tx.consiliation === false || tx.consiliation === undefined}>
                                                            <td>
                                                              
                                                            </td>
                                                        </RenderIf>
                                                        <RenderIf isTrue={tx.consiliation === true}>
                                                            <td>
                                                                <span className='rounded-pill text-on icon-on small px-2'> <i class="uil uil-check"></i> Encontrado</span>

                                                            </td>
                                                        </RenderIf> */}
                                                        </tr>
                                                    </RenderIf>
                                                ))}
                                            </tbody>
                                        </table>
                                        <RenderIf isTrue={someConsiliated !== false}>
                                            <ReactPaginate
                                                previousLabel={"Anterior"}
                                                nextLabel={"Siguiente"}
                                                pageClassName="page-item"
                                                pageLinkClassName="page-link"
                                                previousClassName="page-item"
                                                previousLinkClassName="page-link"
                                                nextClassName="page-item"
                                                nextLinkClassName="page-link"
                                                breakLabel="..."
                                                breakClassName="page-item"
                                                breakLinkClassName="page-link"
                                                pageCount={Math.ceil(orders.length / ordersDataPerPage)}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={5}
                                                onPageChange={handlePageChange}
                                                containerClassName="pagination"
                                                activeClassName="active"
                                            />
                                        </RenderIf>

                                    </div>

                                </div>

                            </section>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}

export default LotInfoTransaction